import type { InternalAxiosRequestConfig as IARC } from 'axios'
import type { ApiOptions, ApiResponse, ApiError } from './declare'
import $consts from 'src/plugins/consts'
import $evt from 'src/plugins/evt'
import { apiOptions } from './config'
import { get, merge } from 'lodash'

export type RequestSuccessFulfilled = ((value: IARC) => IARC | Promise<IARC>) | null
const reqSuccess = (onFulfilled?: RequestSuccessFulfilled) => {
  const onSuccess = (config: ApiOptions & IARC) => {
    // loading 提示
    if (!config.noShowLoading) {
      $evt.emit($consts['EVT/API_REQUEST_SUCCESS'], config.url)
    }

    return onFulfilled?.(config) ?? config
  }
  return onSuccess
}

export type RequestFailRejected = ((error: any) => any) | null
const reqFail = (onRejected?: RequestFailRejected) => {
  const onFail = (err: any) => {
    return onRejected?.(err) ?? Promise.reject(err)
  }
  return onFail
}

export type ResponseSuccessFulfilled = {
  onFulfilled?: ((initResponse: ApiResponse, fulfilledResponse: any, apiOptions: ApiOptions) => ApiResponse | Promise<ApiResponse>) | null,
  onRejected?: ((error: ApiResponse, apiOptions: ApiOptions) => Promise<any>) | null,
  apiOptions?: ApiOptions
}
const resSuccess = (resConfig?: ResponseSuccessFulfilled) => {
  const onSuccess = (resData: ApiResponse): ApiResponse | ApiResponse['data'] | Promise<ApiResponse> => {
    const config = merge({}, apiOptions, resConfig?.apiOptions, resData.config)

    // loading 提示
    if (!config.noShowLoading) {
      $evt.emit($consts['EVT/API_RESPONSE_SUCCESS'], config.url)
    }

    if (!get(resData.data, config.successField!) && !config.noCheckIsSuccessful) {
      // 全局错误提示
      if (!config.noErrorToast) {
        $evt.emit($consts['EVT/API_DATA_ERROR'], JSON.stringify(get(resData.data, config.errorMsgField!)))
      }
      return resConfig?.onRejected?.(resData, config) ?? Promise.reject(resData)
    }
    const defaultFulfilledData = config.fullResponse ? resData : config.fullData ? resData.data : get(resData.data, config.dataField!)
    return resConfig?.onFulfilled?.(resData, defaultFulfilledData, config) ?? defaultFulfilledData
  }
  return onSuccess
}

export type ResponseFailRejected = {
  onRejected?: ((error: any) => any) | null,
  apiOptions?: ApiOptions
}
const resFail = (resConfig?: ResponseFailRejected) => {
  const onFail = (resData: ApiError) => {
    switch (resData.response?.status) {
      case 401: // 登录过期
        $evt.emit($consts['EVT/LOGIN_EXPIRED'])
        break
      default:
        break
    }

    const config = merge({}, apiOptions, resConfig?.apiOptions, resData.config)

    // loading 提示
    if (!config?.noShowLoading) {
      $evt.emit($consts['EVT/API_RESPONSE_FAIL'], config?.url)
    }

    // 全局错误提示
    if (!config?.noErrorToast) {
      $evt.emit($consts['EVT/API_DATA_ERROR'], resData.message ?? resData.response?.statusText ?? '网络错误')
    }

    return resConfig?.onRejected?.(resData) ?? Promise.reject(resData)
  }
  return onFail
}

export type InterceptorConfig = {
  reqSuccess?: RequestSuccessFulfilled,
  reqFail?: RequestFailRejected,
  resSuccess?: ResponseSuccessFulfilled,
  resFail?: ResponseFailRejected,
}
export { reqSuccess, reqFail, resSuccess, resFail }